export function greetings(to) {
    const hours = new Date().getHours();

    if (hours < 12) {
        return `Good morning, ${to}!`;
    }

    if (hours >= 12 && hours <= 17) {
        return `Good afternoon, ${to}!`;
    }

    if (hours >= 17 && hours <= 24) {
        return `Good evening, ${to}!`;
    }
}
